var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.finance.bought
    ? _c("div", { staticClass: "container trade-record-page" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("section", { staticClass: "mt28" }, [
          _c(
            "div",
            { staticClass: "info-card des-group" },
            _vm._l(_vm.options1, function (option, idx) {
              return _c("div", { key: idx, staticClass: "des-group-row b3" }, [
                _c("div", { staticClass: "des-group-row-label bold" }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(option.label) +
                      "\n                "
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "des-group-row-value pdf-row" },
                  [
                    idx === _vm.options1.length - 2
                      ? _vm._l(_vm.pdfs, function (name, urlIdx) {
                          return _c(
                            "a",
                            {
                              key: urlIdx,
                              staticClass: "pdf-item mr40",
                              attrs: {
                                href: "/static/pdf/" + name + ".pdf",
                                target: "_blank",
                              },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "pdf-item-wrapper" },
                                [
                                  _c("pdf-svg"),
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(_vm.pdfDisplayNameMap[name]) +
                                      ".pdf\n                            "
                                  ),
                                ],
                                1
                              ),
                            ]
                          )
                        })
                      : _c("div", [
                          _vm._v(
                            "\n                        " +
                              _vm._s(option.value) +
                              "\n                    "
                          ),
                        ]),
                  ],
                  2
                ),
              ])
            }),
            0
          ),
        ]),
      ])
    : _c("i-empty")
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", [
      _c("h1", { staticClass: "bold" }, [
        _vm._v("\n            取引履歴\n        "),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }